import React, { useEffect } from "react";
import Button from "../common/cta/Button";
import BackIcon from "../../assets/images/BackIcon";
import BackIconInBlack from "../../assets/images/BackIconInBlack";
import { useNavigate } from "react-router-dom";
import { pageRouteConstants } from "../../constants/constants";

interface HeaderWithoutSideMenuProps {
  pageTitle: string;
}

const HeaderWithoutSideMenu: React.FC<HeaderWithoutSideMenuProps> = ({
  pageTitle,
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white ">
      <div className="bg-white text-white justify-center h-[10vh] w-full px-4 flex flex-col ">
        <div className="flex  flex-col justify-start mt-4">
          <button
            onClick={() => {
              navigate(pageRouteConstants.dashBoardRoute); // Navigate to the dashboard route
            }}
            className="my-2 md:mt-0 bg-primary w-[24px] h-[24px] flex items-center justify-center cursor-pointer mr-3  md:ml-0 rounded-lg"
          >
            <BackIcon />
          </button>
          <h1 className="text-xl text-primary font-bold font-poppins ">{pageTitle}</h1>
        </div>
      </div>
    </div>
  );
};

export default HeaderWithoutSideMenu;
